/* eslint-disable no-nested-ternary */
/* eslint-disable eqeqeq */
/* eslint-disable react/require-default-props */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState, useMemo } from "react";
import { Typography, Box } from "@mui/material";
import USER_PENDING_CHATS_DATA from "src/graphql/query/dashboard/PendingTable/userPendingChatsData";
import PENDING_CHAT_COUNT_CHANGED_SUBSCRIPTION from "src/graphql/subscriptions/dashboard/pendingchatcount";
import useActiveUserDetail from "src/utils/shared/useActiveUserDetail";
import { useLazyQuery, useSubscription } from "@apollo/client";
import PendingSkeleton from "src/components/pages/dashboard/skeleton/dashboard/PendingTable";
import { UseDashboardContext } from "src/context/dashboard";
import { useSelector } from "react-redux";
import useAuth from "src/hooks/useAuth";
import { useSnackbar as Snackbar } from "notistack";
import PremiumDonutChart from "./PremiumDonutChart";
import PendingListModal from "./PendingChatListModal";
import useStyles from "./Styles";

interface IPendingPages {
  count: number;
  name: string;
  pageId: string;
  picture: string;
  source: string;
}

const PendingChatStats = () => {
  const { me }: any = useSelector((state: any) => state.me);
  useAuth();
  const { classes } = useStyles();
  const { enqueueSnackbar } = Snackbar();

  // open the pending modal
  const [openModal, setOpenModal] = useState<() => void>(() => () => {});

  const [sourceForViewList, setSourceForViewList] = useState("");
  const handleSourceSelected = (source: string) => {
    setSourceForViewList(
      source.toLowerCase() === "comments" ? "facebook_comments" : source,
    );
  };

  const { agentId, mainSuperAdminId } = useActiveUserDetail();

  const [pendingCount, setPendingCount] = useState(0);

  const [facebookCommentsCount, setFacebookCommentsCount] = useState(0);
  const [facebookCount, setFacebookCount] = useState(0);
  const [instagramCount, setInstagramCount] = useState(0);
  const [whatsAppCount, setWhatsAppCount] = useState(0);
  const [chatbotCount, setChatbotCount] = useState(0);

  const [pendingPages, setPendingPages] = useState<IPendingPages[]>([]);
  const contextData = UseDashboardContext();
  let storedAgentId: any;

  if (contextData) {
    ({ storedAgentId } = contextData);
  }

  // pendingsubscriptiondata
  const {
    data: pendingChatCountChangedSubscriptionResult,
    error: pendingChatCountChangedSubscriptionError,
  } = useSubscription(PENDING_CHAT_COUNT_CHANGED_SUBSCRIPTION);

  useEffect(() => {
    if (pendingChatCountChangedSubscriptionError) {
      enqueueSnackbar(pendingChatCountChangedSubscriptionError.message, {
        variant: "error",
      });
    }
  }, [pendingChatCountChangedSubscriptionError]);

  useEffect(() => {
    if (pendingChatCountChangedSubscriptionResult?.pendingchatcountchanged) {
      const result = JSON.parse(
        pendingChatCountChangedSubscriptionResult.pendingchatcountchanged
          .result,
      );
      if (
        result.mainSuperAdminId == mainSuperAdminId &&
        storedAgentId == agentId
      ) {
        const mePages = me?.pages ? JSON.parse(me.pages) : [];
        const meCommentPages = me?.commentPages
          ? JSON.parse(me.commentPages)
          : [];
        const meChatbotBots = me?.chatbotBots ? JSON.parse(me.chatbotBots) : [];

        const isSuperAdmin = [1, 4].includes(me?.designationId);

        const filteredData = (result.pendingData ?? []).filter(
          (item: {
            count: number;
            name: string;
            pageId: string;
            picture: string;
            source: string;
          }) =>
            (isSuperAdmin || mePages.includes(item.pageId)) &&
            item.source !== "facebook_comments" &&
            item.source !== "chatbot",
        );

        const filteredDataComments = (result.pendingData ?? []).filter(
          (item: {
            count: number;
            name: string;
            pageId: string;
            picture: string;
            source: string;
          }) =>
            (isSuperAdmin || meCommentPages.includes(item.pageId)) &&
            item.source === "facebook_comments",
        );

        const filteredDataChatbots = (result.pendingData ?? []).filter(
          (item: {
            count: number;
            name: string;
            pageId: string;
            picture: string;
            source: string;
          }) =>
            (isSuperAdmin || meChatbotBots.includes(item.pageId)) &&
            item.source === "chatbot",
        );

        const combinedFilteredData = [
          ...filteredData,
          ...filteredDataComments,
          ...filteredDataChatbots,
        ];
        //
        // Calculate counts by source
        // Initialize counts
        let facebookCommentsCountt = 0;
        let facebookCountt = 0;
        let instagramCountt = 0;
        let whatsappCountt = 0;
        let chatbotCountt = 0;

        combinedFilteredData.forEach(
          (item: { source: string; count: number }) => {
            switch (item.source) {
              case "facebook":
                facebookCountt += item.count;
                break;
              case "instagram":
                instagramCountt += item.count;
                break;
              case "whatsapp":
                whatsappCountt += item.count;
                break;
              case "chatbot":
                chatbotCountt += item.count;
                break;
              default:
                facebookCommentsCountt += item.count;
            }
          },
        );
        //
        const totalCount = combinedFilteredData.reduce(
          (total: number, item: { count: number }) => total + item.count,
          0,
        );
        setPendingCount(totalCount);
        setPendingPages(combinedFilteredData);
        //
        setFacebookCommentsCount(facebookCommentsCountt);
        setFacebookCount(facebookCountt);
        setInstagramCount(instagramCountt);
        setWhatsAppCount(whatsappCountt);
        setChatbotCount(chatbotCountt);
      }
    }
  }, [pendingChatCountChangedSubscriptionResult]);

  const [
    getUserPendingChat,
    { data: chatCountResult, loading: chatCountLoading },
  ] = useLazyQuery(USER_PENDING_CHATS_DATA, {
    fetchPolicy: "network-only",
  });

  useEffect(() => {
    if (storedAgentId !== 0) {
      getUserPendingChat({
        variables: {
          agentId: storedAgentId,
        },
      });
    } else {
      // getActiveChatCounts();
    }
  }, [storedAgentId]);

  useEffect(() => {
    if (chatCountResult && chatCountResult.userPendingChatsData) {
      if (chatCountResult.userPendingChatsData.success) {
        const pendingData = JSON.parse(
          chatCountResult.userPendingChatsData.result,
        );

        // Calculate counts by source
        let facebookCommentsCountt = 0;
        let facebookCountt = 0;
        let instagramCountt = 0;
        let whatsappCountt = 0;
        let chatbotCountt = 0;

        pendingData.forEach((item: { source: string; count: number }) => {
          switch (item.source) {
            case "facebook":
              facebookCountt += item.count;
              break;
            case "instagram":
              instagramCountt += item.count;
              break;
            case "whatsapp":
              whatsappCountt += item.count;
              break;
            case "chatbot":
              chatbotCountt += item.count;
              break;
            default:
              facebookCommentsCountt += item.count;
          }
        });
        //
        const totalCount = pendingData.reduce(
          (total: number, item: { count: number }) => total + item.count,
          0,
        );
        setPendingCount(totalCount);
        setPendingPages(pendingData);
        //
        setFacebookCommentsCount(facebookCommentsCountt);
        //
        setFacebookCount(facebookCountt);
        setInstagramCount(instagramCountt);
        setWhatsAppCount(whatsappCountt);
        setChatbotCount(chatbotCountt);
      }
    }
  }, [chatCountResult]);

  const data = useMemo(
    () => [
      {
        label: "Facebook",
        value: pendingCount === 0 ? 0 : (facebookCount / pendingCount) * 100,
        count: facebookCount,
        color: "#1877F2",
      },
      {
        label: "WhatsApp",
        value: pendingCount === 0 ? 0 : (whatsAppCount / pendingCount) * 100,
        count: whatsAppCount,
        color: "#60D669",
      },
      {
        label: "Instagram",
        value: pendingCount === 0 ? 0 : (instagramCount / pendingCount) * 100,
        count: instagramCount,
        color: "#B336AA",
      },
      {
        label: "Comments",
        value:
          pendingCount === 0 ? 0 : (facebookCommentsCount / pendingCount) * 100,
        count: facebookCommentsCount,
        color: "#0F5ACF",
      },
      {
        label: "Chatbot",
        value: pendingCount === 0 ? 0 : (chatbotCount / pendingCount) * 100,
        count: chatbotCount,
        color: "#4D1277",
      },
    ],
    [
      facebookCount,
      whatsAppCount,
      instagramCount,
      facebookCommentsCount,
      chatbotCount,
      pendingCount,
    ],
  );

  return chatCountLoading ? (
    <Box className={classes.flexItem}>
      <PendingSkeleton />
    </Box>
  ) : (
    <>
      <PendingListModal
        setOpenModal={setOpenModal}
        source={sourceForViewList}
        data={pendingPages}
      />
      <Box id="tour-dashboard-pending-stats" className={classes.flexItem}>
        <Box className={classes.headerBox}>
          <Typography className={classes.headerText1}>Statistics</Typography>
          <Typography className={classes.headerText2}>
            Pending Chats ({pendingCount})
          </Typography>
        </Box>

        <Box>
          <PremiumDonutChart
            data={data}
            handleSourceSelected={handleSourceSelected}
            openModal={openModal}
          />
        </Box>
      </Box>
    </>
  );
};

export default PendingChatStats;
